import React, { Component } from 'react'
import { Table } from 'hljd'
import columns from './columns'
import store from '../Search/store'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { list, loading, pagination } = store
    return (
      <Table
        bordered
        dataSource={toJS(list)}
        loading={loading}
        columns={columns}
        pagination={pagination}
        onChange={store.paging}
        style={{ marginTop: 20 }}
      />
    )
  }
}
